var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-dashboard-card',{attrs:{"title":"에너지 사용량","subtitle":"(전사 - 에너지원 단위 - 과거 3개년)"}},[_c('firmwide-energy-by-fuel',{attrs:{"sort":_vm.sort,"height":"250px"},on:{"dataPointSelection":_vm.onDataPointSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }